import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const SearchCont = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',

  // '.ui.input > input':{
  //   borderRadius:'3rem'
  // }
}))

export const DateCont = styled.div((props)=>({
  padding:'.67857143em 1rem',
  border:'1px solid rgba(34,36,38,.15)',
  borderRadius:'.28571429rem',
  background:'#fff'
}))